(function () {
  'use strict';

  var WHATSAPP_DEFAULT_URL = 'https://wa.me/8617531147229';
  var WHATSAPP_MODAL_VERSION = 'whatsapp-modal-v1';
  var WHATSAPP_EVENT_DELAY = 220;
  var LEAD_SUBMIT_SUCCESS_EVENT = 'wika_lead_submit_success';
  var LEAD_VALUE = 100;
  var LEAD_CURRENCY = 'CNY';
  var PRODUCT_INQUIRY_SUCCESS_EVENTS = ['product_inquiry_submit', 'generate_lead'];
  var CONTACT_SUCCESS_EVENTS = ['form_submit', 'generate_lead'];
  var PENDING_LEAD_CONTEXT_KEY = 'wika_pending_lead_form_context';
  var PENDING_LEAD_CONTEXT_TTL_MS = 30 * 60 * 1000;
  var LEAD_SUCCESS_DEDUPE_LOCAL_PREFIX = 'wika_lead_success_dedupe:';
  var LEAD_SUCCESS_PAGE_DEDUPE_PREFIX = 'wika_lead_submit_success_page_v1';
  var LEAD_SUCCESS_DEDUPE_TTL_MS = 7 * 24 * 60 * 60 * 1000;
  var LEAD_NETWORK_DISPATCH_LOCAL_PREFIX = 'wika_lead_network_dispatch:';
  var PENDING_LEAD_NETWORK_DISPATCH_KEY = 'wika_pending_lead_network_dispatch';
  var TAG_DISPATCH_RETRY_INTERVAL_MS = 250;
  var TAG_DISPATCH_RETRY_TIMEOUT_MS = 15000;
  var ATTRIBUTION_STORAGE_KEY = 'wika_attribution_v1';
  var ATTRIBUTION_TTL_MS = 90 * 24 * 60 * 60 * 1000;
  var WHATSAPP_LEAD_EVENT_KEY = 'wika_whatsapp_lead_event_id';
  var GOOGLE_ADS_CONVERSION_ID = 'AW-17188254044';
  var GOOGLE_ADS_LEAD_CONVERSION_LABEL = 'NVXZCKjL5cgcENzi_4NA';
  var GA4_MEASUREMENT_IDS = ['G-YQ2Q78FVNJ'];

  var AD_CLICK_FIELDS = [
    'gclid',
    'gbraid',
    'wbraid',
    'gad_source',
    'gad_campaignid'
  ];

  var UTM_FIELDS = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_term',
    'utm_content'
  ];

  var STORED_ATTRIBUTION_FIELDS = AD_CLICK_FIELDS.concat(UTM_FIELDS);

  var TOUCH_ATTRIBUTION_FIELDS = [
    'first_touch_source',
    'first_touch_medium',
    'first_touch_campaign',
    'first_touch_referrer',
    'first_touch_landing_page',
    'first_touch_timestamp',
    'last_touch_source',
    'last_touch_medium',
    'last_touch_campaign',
    'last_touch_referrer',
    'last_touch_page',
    'last_touch_timestamp',
    'current_page'
  ];

  var ATTRIBUTION_FIELDS = [
    'lead_event_id',
    'source_page',
    'page_url',
    'landing_page',
    'referrer'
  ].concat(STORED_ATTRIBUTION_FIELDS, TOUCH_ATTRIBUTION_FIELDS, [
    'form_type',
    'form_location',
    'is_test',
    'product_handle',
    'collection_handle',
    'page_type'
  ]);

  function safeSessionGet(key) {
    try {
      return window.sessionStorage ? window.sessionStorage.getItem(key) : '';
    } catch (error) {
      return '';
    }
  }

  function safeSessionSet(key, value) {
    try {
      if (window.sessionStorage) {
        window.sessionStorage.setItem(key, value);
      }
    } catch (error) {
      return;
    }
  }

  function safeLocalGet(key) {
    try {
      return window.localStorage ? window.localStorage.getItem(key) : '';
    } catch (error) {
      return '';
    }
  }

  function safeLocalSet(key, value) {
    try {
      if (window.localStorage) {
        window.localStorage.setItem(key, value);
      }
    } catch (error) {
      return;
    }
  }

  function safeLocalRemove(key) {
    try {
      if (window.localStorage) {
        window.localStorage.removeItem(key);
      }
    } catch (error) {
      return;
    }
  }

  function pageUrl() {
    return window.location ? window.location.href : '';
  }

  function landingPage() {
    var key = 'wika_landing_page';
    var stored = safeSessionGet(key);

    if (stored) {
      return stored;
    }

    stored = pageUrl();
    safeSessionSet(key, stored);
    return stored;
  }

  function urlParam(name) {
    try {
      return new URL(window.location.href).searchParams.get(name) || '';
    } catch (error) {
      return '';
    }
  }

  function storedAttribution() {
    var record = safeJsonParse(safeLocalGet(ATTRIBUTION_STORAGE_KEY));

    if (!record || !record.data) {
      return {};
    }

    if (record.expires_at && Date.now() > record.expires_at) {
      safeLocalRemove(ATTRIBUTION_STORAGE_KEY);
      return {};
    }

    return record.data || {};
  }

  function persistAttribution(data) {
    var firstTimestamp = data && data.first_touch ? Date.parse(data.first_touch.timestamp || '') : NaN;
    var expiresAt = Number.isFinite(firstTimestamp)
      ? firstTimestamp + ATTRIBUTION_TTL_MS
      : Date.now() + ATTRIBUTION_TTL_MS;

    safeLocalSet(
      ATTRIBUTION_STORAGE_KEY,
      JSON.stringify({
        data: data || {},
        expires_at: expiresAt
      })
    );
  }

  function cleanString(value) {
    return value === undefined || value === null ? '' : String(value).trim();
  }

  function referrerHost(referrer) {
    try {
      return new URL(referrer).hostname.toLowerCase().replace(/^www\./, '');
    } catch (error) {
      return '';
    }
  }

  function isInternalReferrer(referrer) {
    var host = referrerHost(referrer);
    var currentHost = window.location && window.location.hostname
      ? window.location.hostname.toLowerCase().replace(/^www\./, '')
      : '';

    return !!host && host === currentHost;
  }

  function canonicalAiSource(value) {
    var source = cleanString(value).toLowerCase().replace(/^https?:\/\//, '').replace(/^www\./, '').split('/')[0];

    if (/^(chatgpt\.com|chat\.openai\.com|openai\.com)$/.test(source)) {
      return 'chatgpt.com';
    }

    if (/^(perplexity\.ai|claude\.ai|gemini\.google\.com|copilot\.microsoft\.com|ai-assistant)$/.test(source)) {
      return source;
    }

    return '';
  }

  function currentInboundParams() {
    var params = {};

    STORED_ATTRIBUTION_FIELDS.forEach(function (field) {
      var value = cleanString(urlParam(field));

      if (value) {
        params[field] = value;
      }
    });

    return params;
  }

  function touchSource(params, referrer) {
    var utmSource = cleanString(params.utm_source);
    var utmMedium = cleanString(params.utm_medium);
    var utmCampaign = cleanString(params.utm_campaign);
    var aiSource = canonicalAiSource(utmSource);
    var host = referrerHost(referrer);
    var aiReferrer = canonicalAiSource(host);

    if (params.gclid || params.gbraid || params.wbraid) {
      return { source: 'google', medium: 'cpc', campaign: utmCampaign };
    }

    if (aiSource || utmMedium.toLowerCase() === 'ai-assistant') {
      return {
        source: aiSource || utmSource || aiReferrer || 'ai-assistant',
        medium: utmMedium || 'ai-assistant',
        campaign: utmCampaign
      };
    }

    if (utmSource || utmMedium || utmCampaign) {
      return {
        source: utmSource || '(not set)',
        medium: utmMedium || '(not set)',
        campaign: utmCampaign
      };
    }

    if (aiReferrer) {
      return { source: aiReferrer, medium: 'ai-assistant', campaign: '' };
    }

    if (/(^|\.)google\./.test(host)) {
      return { source: 'google', medium: 'organic', campaign: '' };
    }

    if (host && !isInternalReferrer(referrer)) {
      return { source: host, medium: 'referral', campaign: '' };
    }

    return { source: '(direct)', medium: '(none)', campaign: '' };
  }

  function hasNewTouchSignal(params, referrer) {
    return Object.keys(params || {}).some(function (key) {
      return !!cleanString(params[key]);
    }) || (!!referrerHost(referrer) && !isInternalReferrer(referrer));
  }

  function buildTouch(params, referrer, page, previous, firstTouch) {
    var source = touchSource(params, referrer);
    var hasNewSignal = hasNewTouchSignal(params, referrer);
    var touch = !firstTouch && previous && !hasNewSignal
      ? {
          source: previous.source || '(direct)',
          medium: previous.medium || '(none)',
          campaign: previous.campaign || '',
          referrer: previous.referrer || ''
        }
      : {
          source: source.source,
          medium: source.medium,
          campaign: source.campaign,
          referrer: cleanString(referrer)
        };

    touch.timestamp = new Date().toISOString();
    if (firstTouch) {
      touch.landing_page = page;
      touch.gclid = cleanString(params.gclid);
      touch.gbraid = cleanString(params.gbraid);
      touch.wbraid = cleanString(params.wbraid);
    } else {
      touch.page = page;
    }

    return touch;
  }

  function legacyFirstTouch(stored) {
    if (!stored || (!stored.landing_page && !stored.referrer && !stored.utm_source && !stored.gclid && !stored.gbraid && !stored.wbraid)) {
      return null;
    }

    var source = touchSource(stored, stored.referrer || '');
    return {
      source: source.source,
      medium: source.medium,
      campaign: source.campaign,
      referrer: stored.referrer || '',
      landing_page: stored.landing_page || landingPage(),
      timestamp: new Date().toISOString(),
      gclid: stored.gclid || '',
      gbraid: stored.gbraid || '',
      wbraid: stored.wbraid || ''
    };
  }

  function flattenTouches(data) {
    var first = data.first_touch || {};
    var last = data.last_touch || {};

    data.first_touch_source = first.source || '(direct)';
    data.first_touch_medium = first.medium || '(none)';
    data.first_touch_campaign = first.campaign || '';
    data.first_touch_referrer = first.referrer || '';
    data.first_touch_landing_page = first.landing_page || '';
    data.first_touch_timestamp = first.timestamp || '';
    data.last_touch_source = last.source || data.first_touch_source;
    data.last_touch_medium = last.medium || data.first_touch_medium;
    data.last_touch_campaign = last.campaign || '';
    data.last_touch_referrer = last.referrer || '';
    data.last_touch_page = last.page || pageUrl();
    data.last_touch_timestamp = last.timestamp || '';
    data.current_page = pageUrl();
    data.landing_page = data.first_touch_landing_page || landingPage();
    data.referrer = data.last_touch_referrer || data.first_touch_referrer || '';
    return data;
  }

  function captureAttribution() {
    var stored = Object.assign({}, storedAttribution());
    var params = currentInboundParams();
    var currentPage = pageUrl();
    var currentReferrer = document.referrer || '';
    var first = stored.first_touch || legacyFirstTouch(stored);
    var last = stored.last_touch || null;
    var data = Object.assign({}, stored);

    if (!first) {
      first = buildTouch(params, currentReferrer, currentPage, null, true);
      safeSessionSet('wika_landing_page', first.landing_page);
    }

    last = buildTouch(params, currentReferrer, currentPage, last || first, false);
    data.first_touch = first;
    data.last_touch = last;

    STORED_ATTRIBUTION_FIELDS.forEach(function (field) {
      data[field] = cleanString(params[field]) || cleanString(stored[field]) || cleanString(first[field]);
    });

    flattenTouches(data);
    persistAttribution(data);
    return data;
  }

  function pathHandle(segmentName) {
    var parts = window.location.pathname.split('/').filter(Boolean);
    var index = parts.indexOf(segmentName);

    if (index === -1 || !parts[index + 1]) {
      return '';
    }

    return decodeURIComponent(parts[index + 1]);
  }

  function inferPageType() {
    var parts = window.location.pathname.split('/').filter(Boolean);

    if (!parts.length) {
      return 'index';
    }

    if (parts.indexOf('products') !== -1) {
      return 'product';
    }

    if (parts.indexOf('collections') !== -1) {
      return 'collection';
    }

    if (parts[0] === 'pages') {
      return 'page';
    }

    return parts[0] || '';
  }

  function baseContext() {
    var context = window.wikaDataClosureContext || {};

    return {
      page_url: pageUrl(),
      page_location: pageUrl(),
      page_path: window.location ? window.location.pathname : '',
      page_title: document.title || '',
      page_type: context.page_type || inferPageType(),
      product_handle: context.product_handle || pathHandle('products'),
      collection_handle: context.collection_handle || pathHandle('collections')
    };
  }

  function attribution() {
    var data = baseContext();
    var stored = captureAttribution();

    TOUCH_ATTRIBUTION_FIELDS.forEach(function (field) {
      data[field] = stored[field] || '';
    });

    data.landing_page = stored.first_touch_landing_page || stored.landing_page || landingPage();
    data.referrer = stored.last_touch_referrer || stored.first_touch_referrer || stored.referrer || document.referrer || '';

    STORED_ATTRIBUTION_FIELDS.forEach(function (field) {
      data[field] = stored[field] || cleanString(urlParam(field));
    });

    return data;
  }

  function findInput(form, name) {
    return form.querySelector('input[name="' + name + '"]');
  }

  function ensureHiddenInput(form, name) {
    var input = findInput(form, name);

    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      form.appendChild(input);
    }

    return input;
  }

  function createLeadEventId() {
    var randomPart = Math.random().toString(36).slice(2, 10);
    return ['wika', Date.now(), randomPart].join('_');
  }

  function leadEventId(form, createIfMissing) {
    var input = form ? findInput(form, 'contact[lead_event_id]') : null;
    var existing = input && input.value ? String(input.value).trim() : '';

    if (!existing && form && form.getAttribute('data-wika-lead-event-id')) {
      existing = form.getAttribute('data-wika-lead-event-id');
    }

    if (!existing && createIfMissing) {
      existing = createLeadEventId();
    }

    if (existing && form) {
      form.setAttribute('data-wika-lead-event-id', existing);
      ensureHiddenInput(form, 'contact[lead_event_id]').value = existing;
    }

    return existing;
  }

  function isNewsletterForm(form) {
    var tagInput = form.querySelector('input[name="contact[tags]"]');
    return !!(tagInput && String(tagInput.value).toLowerCase().indexOf('newsletter') !== -1);
  }

  function isLeadForm(form) {
    if (!form || form.tagName !== 'FORM' || isNewsletterForm(form)) {
      return false;
    }

    if (form.id === 'ContactForm' || form.id === 'ProductInquiryForm' || form.classList.contains('wkpd-inquiry-form')) {
      return true;
    }

    return !!(
      form.querySelector('[name="contact[email]"]') &&
      form.querySelector('textarea[name^="contact["]')
    );
  }

  function isTestLead(form) {
    var explicitMarkers = [urlParam('wika_test'), urlParam('test')].map(cleanString).filter(Boolean);
    var marker = '';

    if (explicitMarkers.some(function (value) { return value === '1'; })) {
      return true;
    }

    if (form && form.elements) {
      Array.prototype.forEach.call(form.elements, function (field) {
        if (field && typeof field.value === 'string') {
          marker += ' ' + field.value;
        }
      });
    }

    return isTestMarker(marker);
  }

  function isTestMarker(value) {
    var marker = '';

    try {
      marker = decodeURIComponent(String(value || ''));
    } catch (error) {
      marker = String(value || '');
    }

    return (
      /(?:^|[?&#])(wika_test|test)(?:=|%3d)1(?:[&#\s]|$)/i.test(marker) ||
      /(^|[^A-Z0-9])TEST([^A-Z0-9]|$)/.test(marker) ||
      /do[-_\s]?not[-_\s]?quote|wika[-_\s]?tracking|manual_validation|tracking_test|tag[-_\s]?assistant|final[-_\s]?validation/i.test(marker) ||
      /[A-Z0-9._%+-]+@(?:[A-Z0-9-]+\.)*example\.com\b/i.test(marker)
    );
  }

  function isTestAttribution(data) {
    data = data || {};

    return isTestMarker([
      data.page_url,
      data.page_location,
      data.source_page,
      data.landing_page,
      data.referrer,
      data.utm_source,
      data.utm_medium,
      data.utm_campaign,
      data.utm_term,
      data.utm_content
    ].join(' '));
  }

  function fillLeadForm(form, options) {
    if (!isLeadForm(form)) {
      return false;
    }

    options = options || {};

    var data = attribution();
    data.lead_event_id = leadEventId(form, !!options.createLeadEventId);
    data.source_page = safeSessionGet('wika_last_quote_source_page') || data.page_url || pageUrl();
    data.current_page = data.page_url || pageUrl();
    data.form_type = leadFormType(form);
    data.form_location = sourceContext(form);
    data.is_test = isTestLead(form) || isTestAttribution(data) ? 'true' : 'false';

    ATTRIBUTION_FIELDS.forEach(function (field) {
      ensureHiddenInput(form, 'contact[' + field + ']').value = data[field] || '';
    });

    return true;
  }

  function formFieldValue(form, names) {
    var value = '';

    if (!form) {
      return value;
    }

    names.some(function (name) {
      var field = form.elements ? form.elements[name] : null;

      if (!field) {
        field = form.querySelector('[name="' + name + '"]');
      }

      if (field && field.length && field[0] && field[0].value !== undefined) {
        value = field[0].value;
      } else if (field && field.value !== undefined) {
        value = field.value;
      }

      value = value ? String(value).trim() : '';
      return !!value;
    });

    return value;
  }

  function metaContent(selector) {
    var node = document.querySelector(selector);
    return node ? node.getAttribute('content') || '' : '';
  }

  function pageHeading() {
    var heading = document.querySelector('h1');
    return heading ? (heading.textContent || '').trim() : '';
  }

  function productLeadDetails(form, formType) {
    if (formType !== 'product_inquiry_form') {
      return {};
    }

    return {
      lead_type: 'product_inquiry',
      product_title:
        formFieldValue(form, ['contact[Product Title]', 'contact[product_title]']) ||
        metaContent('meta[property="og:title"]') ||
        pageHeading() ||
        document.title ||
        '',
      product_url:
        formFieldValue(form, ['contact[Product Link]', 'contact[product_url]', 'contact[Current Page]']) ||
        metaContent('meta[property="og:url"]') ||
        pageUrl(),
      quantity: formFieldValue(form, ['contact[quantity]', 'contact[Quantity]']),
      customization: formFieldValue(form, ['contact[customization]', 'contact[Customization]', 'contact[Logo / customization request]'])
    };
  }

  function cleanParams(params) {
    var cleaned = {};

    Object.keys(params || {}).forEach(function (key) {
      var value = params[key];
      if (value !== undefined && value !== null) {
        cleaned[key] = value;
      }
    });

    return cleaned;
  }

  function pushDataLayerEvent(eventName, params) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: eventName }, cleanParams(params)));
      return true;
    } catch (error) {
      return false;
    }
  }

  function leadDebugEnabled(params) {
    return !!(
      (params && (params.is_test === true || params.is_test === 'true')) ||
      urlParam('wika_test') === '1' ||
      urlParam('wika_debug') === '1'
    );
  }

  function leadDebug(params, message, detail) {
    if (!leadDebugEnabled(params)) {
      return;
    }

    try {
      if (window.console && typeof window.console.debug === 'function') {
        window.console.debug('[WIKA lead tracking] ' + message, detail || '');
      }
    } catch (error) {
      return;
    }
  }

  function networkDispatchDedupeKey(params) {
    var leadId = params && (params.lead_event_id || params.event_id);

    if (leadId) {
      return 'wika_lead_network_dispatch_' + leadId;
    }

    return 'wika_lead_network_dispatch_fallback_' + [
      params && params.page_path ? params.page_path : pagePath(),
      params && params.form_id ? params.form_id : '',
      params && params.success_context_source ? params.success_context_source : '',
      new Date().toISOString().slice(0, 10)
    ].join('_');
  }

  function networkDispatchStorageKey(key) {
    return LEAD_NETWORK_DISPATCH_LOCAL_PREFIX + key;
  }

  function hasLeadNetworkDispatchDedupe(params) {
    var key = networkDispatchDedupeKey(params);
    var localRecord = safeJsonParse(safeLocalGet(networkDispatchStorageKey(key)));

    if (safeSessionGet(key) === 'true') {
      return true;
    }

    if (!localRecord || !localRecord.fired) {
      return false;
    }

    if (localRecord.expires_at && Date.now() > localRecord.expires_at) {
      safeLocalRemove(networkDispatchStorageKey(key));
      return false;
    }

    return true;
  }

  function markLeadNetworkDispatchDedupe(params, result) {
    var key = networkDispatchDedupeKey(params);

    safeSessionSet(key, 'true');
    safeLocalSet(networkDispatchStorageKey(key), JSON.stringify({
      fired: true,
      lead_event_id: params.lead_event_id || params.event_id || '',
      dedupe_key: key,
      fired_at: Date.now(),
      expires_at: Date.now() + LEAD_SUCCESS_DEDUPE_TTL_MS,
      ga4: !!(result && result.ga4),
      google_ads: !!(result && result.google_ads)
    }));
  }

  function ga4LeadPayload(params) {
    var payload = cleanParams(params);

    return Object.assign(payload, {
      event_id: params.lead_event_id || params.event_id || '',
      lead_event_id: params.lead_event_id || params.event_id || '',
      value: LEAD_VALUE,
      currency: LEAD_CURRENCY,
      lead_type: params.lead_type || 'form_submit',
      form_type: params.form_type || '',
      form_location: params.form_location || '',
      page_path: params.page_path || pagePath(),
      page_title: document.title || '',
      gclid_present: !!params.gclid_present,
      gbraid_present: !!params.gbraid_present,
      wbraid_present: !!params.wbraid_present,
      is_test: params.is_test === true || params.is_test === 'true'
    });
  }

  function sendGa4LeadEvent(params) {
    var sentCount = 0;

    if (typeof window.gtag !== 'function') {
      return false;
    }

    GA4_MEASUREMENT_IDS.forEach(function (measurementId) {
      if (!measurementId) {
        return;
      }

      try {
        window.gtag('event', 'generate_lead', Object.assign({
          send_to: measurementId
        }, ga4LeadPayload(params)));
        sentCount += 1;
      } catch (error) {
        leadDebug(params, 'GA4 generate_lead dispatch failed', {
          measurement_id: measurementId,
          error: error && error.message ? error.message : String(error)
        });
      }
    });

    return sentCount > 0;
  }

  function sendGoogleAdsLeadConversion(params) {
    if (!GOOGLE_ADS_LEAD_CONVERSION_LABEL || typeof window.gtag !== 'function') {
      return false;
    }

    try {
      window.gtag('event', 'conversion', Object.assign({
        send_to: GOOGLE_ADS_CONVERSION_ID + '/' + GOOGLE_ADS_LEAD_CONVERSION_LABEL,
        value: LEAD_VALUE,
        currency: LEAD_CURRENCY,
        transaction_id: params.lead_event_id || params.event_id || ''
      }, cleanParams(params)));
      return true;
    } catch (error) {
      return false;
    }
  }

  function dispatchLeadNetworkTags(params) {
    var result = {
      ga4: false,
      google_ads: false
    };

    if (typeof window.gtag !== 'function') {
      return result;
    }

    result.ga4 = sendGa4LeadEvent(params);
    result.google_ads = sendGoogleAdsLeadConversion(params);
    return result;
  }

  function leadNetworkDispatchComplete(result) {
    return !!(result && result.ga4 && result.google_ads);
  }

  function scheduleLeadNetworkDispatch(params) {
    var startedAt = Date.now();
    var payload = cleanParams(params);

    if (hasLeadNetworkDispatchDedupe(payload)) {
      leadDebug(payload, 'Skipped duplicate network dispatch', {
        lead_event_id: payload.lead_event_id || payload.event_id || ''
      });
      return;
    }

    safeSessionSet(PENDING_LEAD_NETWORK_DISPATCH_KEY, JSON.stringify({
      params: payload,
      queued_at: startedAt,
      expires_at: startedAt + TAG_DISPATCH_RETRY_TIMEOUT_MS
    }));

    function attempt() {
      var result;

      if (hasLeadNetworkDispatchDedupe(payload)) {
        safeSessionRemove(PENDING_LEAD_NETWORK_DISPATCH_KEY);
        return;
      }

      result = dispatchLeadNetworkTags(payload);

      if (leadNetworkDispatchComplete(result)) {
        markLeadNetworkDispatchDedupe(payload, result);
        safeSessionRemove(PENDING_LEAD_NETWORK_DISPATCH_KEY);
        leadDebug(payload, 'Network dispatch completed', result);
        return;
      }

      if (Date.now() - startedAt >= TAG_DISPATCH_RETRY_TIMEOUT_MS) {
        leadDebug(payload, 'Network dispatch failed after retry window', result);
        return;
      }

      window.setTimeout(attempt, TAG_DISPATCH_RETRY_INTERVAL_MS);
    }

    attempt();
  }

  function retryPendingLeadNetworkDispatch() {
    var pending = safeJsonParse(safeSessionGet(PENDING_LEAD_NETWORK_DISPATCH_KEY));

    if (!pending || !pending.params || (pending.expires_at && Date.now() > pending.expires_at)) {
      safeSessionRemove(PENDING_LEAD_NETWORK_DISPATCH_KEY);
      return;
    }

    scheduleLeadNetworkDispatch(pending.params);
  }

  function sendEvent(eventName, params) {
    var payload = cleanParams(params);
    var dataLayerPayload = Object.assign({ event: eventName }, payload);
    var sent = {
      gtag: false,
      dataLayer: false,
      shopify: false
    };

    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(dataLayerPayload);
      sent.dataLayer = true;
    } catch (error) {
      sent.dataLayer = false;
    }

    try {
      if (typeof window.gtag === 'function') {
        window.gtag(
          'event',
          eventName,
          eventName === 'generate_lead'
            ? Object.assign({ send_to: GA4_MEASUREMENT_IDS }, payload)
            : payload
        );
        sent.gtag = true;
      }
    } catch (error) {
      sent.gtag = false;
    }

    try {
      if (
        window.Shopify &&
        window.Shopify.analytics &&
        typeof window.Shopify.analytics.publish === 'function'
      ) {
        window.Shopify.analytics.publish(eventName, payload);
        sent.shopify = true;
      }
    } catch (error) {
      sent.shopify = false;
    }

    return sent;
  }

  function leadFormType(form) {
    if (!form) {
      return '';
    }

    if (form.id === 'ProductInquiryForm' || form.classList.contains('wkpd-inquiry-form')) {
      return 'product_inquiry_form';
    }

    return 'contact_form';
  }

  function leadFormContext(form, status) {
    var data = attribution();
    var formId = form && form.id ? form.id : '';
    var formType = leadFormType(form);
    var leadType = formType === 'product_inquiry_form' ? 'product_inquiry' : 'contact_form';
    var leadId = leadEventId(form, status === 'pending' || status === 'success');
    var gclid = data.gclid || '';
    var gbraid = data.gbraid || '';
    var wbraid = data.wbraid || '';

    return Object.assign(data, productLeadDetails(form, formType), {
      event_id: leadId,
      lead_event_id: leadId,
      event_category: 'lead',
      event_label: status === 'success' ? 'form_submit_success' : 'form_start',
      lead_type: leadType,
      contact_method: 'form',
      form_id: formId,
      form_type: formType,
      form_location: sourceContext(form),
      form_status: status || '',
      source: formType || 'contact_form',
      source_page: data.page_url || pageUrl(),
      source_cta: safeSessionGet('wika_last_quote_cta') || '',
      value: LEAD_VALUE,
      currency: LEAD_CURRENCY,
      gclid_present: !!gclid,
      gbraid_present: !!gbraid,
      wbraid_present: !!wbraid,
      is_test: isTestLead(form) || isTestAttribution(data)
    });
  }

  function rememberPendingLeadForm(form) {
    fillLeadForm(form, { createLeadEventId: true });

    var payload = leadFormContext(form, 'pending');
    var returnTo = prepareContactSuccessReturn(form, payload.lead_event_id);

    payload.pending_created_at = Date.now();
    payload.expected_success_path = returnTo ? returnTo.pathname : window.location.pathname;
    payload.expected_success_hash = returnTo ? returnTo.hash : (form.id ? '#' + form.id : '');

    try {
      safeSessionSet(PENDING_LEAD_CONTEXT_KEY, JSON.stringify(payload));
    } catch (error) {
      return;
    }
  }

  function prepareContactSuccessReturn(form, leadEventId) {
    var returnToInput;
    var returnToUrl;

    if (!form || form.id !== 'ContactForm' || !leadEventId) {
      return null;
    }

    returnToInput = form.querySelector('input[name="return_to"]');
    if (!returnToInput) {
      return null;
    }

    try {
      returnToUrl = new URL(returnToInput.value || window.location.pathname, window.location.origin);
      returnToUrl.searchParams.set('contact_posted', 'true');
      returnToUrl.searchParams.set('wika_lead_event_id', leadEventId);
      returnToUrl.hash = form.id;
      returnToInput.value = returnToUrl.pathname + returnToUrl.search + returnToUrl.hash;
      return returnToUrl;
    } catch (error) {
      return null;
    }
  }

  function successEventKey(params) {
    if (params.lead_event_id) {
      return 'wika_lead_submit_success_' + params.lead_event_id;
    }

    return fallbackSuccessEventKey(params);
  }

  function fallbackSuccessEventKey(params) {
    return [
      'wika_lead_success_sent_v4',
      params.form_id || 'contact_form',
      params.page_path || (window.location ? window.location.pathname : ''),
      params.landing_page || ''
    ].join(':');
  }

  function successPageDedupeKey(params) {
    return [
      LEAD_SUCCESS_PAGE_DEDUPE_PREFIX,
      params.form_id || 'contact_form',
      params.page_path || (window.location ? window.location.pathname : ''),
      hasContactPostedSuccessUrl() ? 'contact_posted' : 'success_marker'
    ].join(':');
  }

  function localDedupeStorageKey(key) {
    return LEAD_SUCCESS_DEDUPE_LOCAL_PREFIX + key;
  }

  function localDedupeRecord(key) {
    var record = safeJsonParse(safeLocalGet(localDedupeStorageKey(key)));

    if (!record || !record.fired) {
      return null;
    }

    if (record.expires_at && Date.now() > record.expires_at) {
      safeLocalRemove(localDedupeStorageKey(key));
      return null;
    }

    return record;
  }

  function hasLeadSuccessDedupeKey(key) {
    return safeSessionGet(key) === 'true' || !!localDedupeRecord(key);
  }

  function markLeadSuccessDedupeKey(key, params, source) {
    safeSessionSet(key, 'true');
    safeLocalSet(localDedupeStorageKey(key), JSON.stringify({
      fired: true,
      lead_event_id: params.lead_event_id || '',
      dedupe_key: key,
      fired_at: Date.now(),
      expires_at: Date.now() + LEAD_SUCCESS_DEDUPE_TTL_MS,
      source: source || params.success_context_source || '',
      page_path: params.page_path || '',
      is_test: params.is_test === true || params.is_test === 'true'
    }));
  }

  function uniqueKeys(keys) {
    var seen = {};
    return keys.filter(function (key) {
      if (!key || seen[key]) {
        return false;
      }
      seen[key] = true;
      return true;
    });
  }

  function leadSuccessDedupeKeys(params) {
    var keys = [];

    if (params.lead_event_id) {
      keys.push(successEventKey(params));
    }

    keys.push(fallbackSuccessEventKey(params));
    keys.push(successPageDedupeKey(params));

    return uniqueKeys(keys);
  }

  function hasLeadSuccessDedupe(params, includePageKey) {
    // A fresh, matched submission has its own identity. Older page-level
    // fallback keys must not suppress a different inquiry from this visitor.
    // Keep the broad fallback checks for success-page revisits without it.
    if (includePageKey === false && params.fallback === false && params.lead_event_id) {
      return hasLeadSuccessDedupeKey(successEventKey(params));
    }

    var pageKey = successPageDedupeKey(params);
    var keys = leadSuccessDedupeKeys(params).filter(function (key) {
      return includePageKey || key !== pageKey;
    });

    return keys.some(hasLeadSuccessDedupeKey);
  }

  function markLeadSuccessDedupe(params) {
    leadSuccessDedupeKeys(params).forEach(function (key) {
      markLeadSuccessDedupeKey(key, params);
    });
  }

  function markLeadSuccessCandidatesSent(candidates) {
    candidates.forEach(function (candidate) {
      if (candidate.marker) {
        candidate.marker.setAttribute('data-wika-lead-event-sent', 'true');
      }
    });
  }

  function leadSuccessCandidatePriority(candidate) {
    if (candidate.source === 'shopify_success_marker') {
      return 40;
    }

    if (candidate.source === 'contact_posted_success_url') {
      return 30;
    }

    if (candidate.source === 'contact_success_message') {
      return 20;
    }

    return 10;
  }

  function selectLeadSuccessCandidate(candidates) {
    return candidates.slice().sort(function (left, right) {
      return leadSuccessCandidatePriority(right) - leadSuccessCandidatePriority(left);
    })[0] || null;
  }

  function currentHashId() {
    try {
      return window.location && window.location.hash ? decodeURIComponent(window.location.hash.replace(/^#/, '')) : '';
    } catch (error) {
      return '';
    }
  }

  function hasContactPostedSuccessUrl() {
    return urlParam('contact_posted') === 'true';
  }

  function freshPendingLeadContext(pending) {
    var createdAt;

    if (!pending || pending.form_status !== 'pending' || !pending.lead_event_id) {
      return false;
    }

    createdAt = Number(pending.pending_created_at || 0);
    return !!createdAt && Date.now() >= createdAt && Date.now() - createdAt <= PENDING_LEAD_CONTEXT_TTL_MS;
  }

  function pendingMatchesSuccessPage(pending, form) {
    if (!freshPendingLeadContext(pending) || !form || pending.form_id !== form.id) {
      return false;
    }

    if (pending.expected_success_path && pending.expected_success_path !== window.location.pathname) {
      return false;
    }

    if (pending.expected_success_hash && pending.expected_success_hash !== window.location.hash) {
      return false;
    }

    return true;
  }

  function contactSuccessUrlMatchesPending(pending, form) {
    var urlLeadEventId = urlParam('wika_lead_event_id');

    return !!(
      hasContactPostedSuccessUrl() &&
      pendingMatchesSuccessPage(pending, form) &&
      urlLeadEventId &&
      urlLeadEventId === pending.lead_event_id
    );
  }

  function navigationEntry() {
    try {
      return window.performance && window.performance.getEntriesByType
        ? window.performance.getEntriesByType('navigation')[0] || null
        : null;
    } catch (error) {
      return null;
    }
  }

  function formHasLeadError(form) {
    return !!(
      form &&
      form.querySelector(
        '[aria-invalid="true"], .contact__field-error, .wkpd-form-status--error, .form-status[role="alert"]'
      )
    );
  }

  function legacyContactReturnMatchesPending(pending, form) {
    var navigation = navigationEntry();

    return !!(
      !hasContactPostedSuccessUrl() &&
      pendingMatchesSuccessPage(pending, form) &&
      !formHasLeadError(form) &&
      navigation &&
      navigation.type === 'navigate' &&
      navigation.redirectCount > 0
    );
  }

  function pageHasLeadSuccessMessage() {
    var text = document.body ? document.body.textContent || '' : '';

    return /inquiry has been (sent|submitted) successfully|thank you\. your inquiry has been submitted successfully/i.test(text);
  }

  function explicitLeadSuccessMessages() {
    var selectors = '.form-status.form__message, .wkpd-form-status--ok, [role="status"]';

    return Array.prototype.filter.call(document.querySelectorAll(selectors), function (node) {
      var text = node.textContent || '';
      return (
        !node.hasAttribute('data-wika-lead-success') &&
        !node.matches('[role="alert"]') &&
        /inquiry has been (sent|submitted) successfully|thank you\. your inquiry has been submitted successfully/i.test(text)
      );
    });
  }

  function findLeadSuccessForm(marker) {
    var hashId = currentHashId();
    var hashTarget;
    var form;

    if (marker) {
      form = closestMatching(marker, 'form');
      if (form) {
        return form;
      }
    }

    if (hashId) {
      hashTarget = document.getElementById(hashId);
      if (hashTarget && hashTarget.tagName === 'FORM') {
        return hashTarget;
      }
      form = hashTarget ? closestMatching(hashTarget, 'form') : null;
      if (form) {
        return form;
      }
    }

    return (
      document.getElementById('ProductInquiryForm') ||
      document.getElementById('ContactForm') ||
      document.querySelector('.wkpd-inquiry-form') ||
      document.querySelector('form[action*="/contact"]')
    );
  }

  function leadSuccessCandidates(pending) {
    var candidates = [];
    var markers = document.querySelectorAll('[data-wika-lead-success="contact_form"]');
    var messageMarkers = explicitLeadSuccessMessages();
    var hashId = currentHashId();
    var urlSuccessForm;

    Array.prototype.forEach.call(markers, function (marker) {
      candidates.push({
        form: findLeadSuccessForm(marker),
        marker: marker,
        source: 'shopify_success_marker'
      });
    });

    Array.prototype.forEach.call(messageMarkers, function (marker) {
      candidates.push({
        form: findLeadSuccessForm(marker),
        marker: marker,
        source: 'contact_success_message'
      });
    });

    urlSuccessForm = findLeadSuccessForm();

    if (
      urlSuccessForm &&
      hashId === urlSuccessForm.id &&
      contactSuccessUrlMatchesPending(pending, urlSuccessForm)
    ) {
      candidates.push({
        form: urlSuccessForm,
        marker: null,
        source: 'contact_posted_success_url'
      });
    }

    if (urlSuccessForm && hashId === urlSuccessForm.id && legacyContactReturnMatchesPending(pending, urlSuccessForm)) {
      candidates.push({
        form: urlSuccessForm,
        marker: null,
        source: 'contact_return_navigation'
      });
    }

    return candidates;
  }

  function dispatchLeadSuccessWindowEvent(params) {
    try {
      window.dispatchEvent(new CustomEvent(LEAD_SUBMIT_SUCCESS_EVENT, { detail: cleanParams(params) }));
      return true;
    } catch (error) {
      return false;
    }
  }

  function leadSuccessEventsFor(formType) {
    if (formType === 'product_inquiry_form') {
      return PRODUCT_INQUIRY_SUCCESS_EVENTS;
    }

    return CONTACT_SUCCESS_EVENTS;
  }

  function sendLeadSuccessEvent(eventName, params) {
    if (eventName === 'product_inquiry_submit' || eventName === 'generate_lead') {
      return { dataLayer: pushDataLayerEvent(eventName, params), gtag: false, shopify: false };
    }

    return sendEvent(eventName, params);
  }

  function sendLeadSuccessEvents() {
    var pending = safeJsonParse(safeSessionGet(PENDING_LEAD_CONTEXT_KEY));
    var hasPendingContext = freshPendingLeadContext(pending);
    var successCandidates = leadSuccessCandidates(hasPendingContext ? pending : null);
    var candidate;
    var form;
    var successContext;
    var params;

    if (!successCandidates.length) {
      return false;
    }

    candidate = selectLeadSuccessCandidate(successCandidates);
    if (!candidate) {
      return false;
    }

    form = candidate.form;
    hasPendingContext = hasPendingContext && pendingMatchesSuccessPage(pending, form) &&
      !formHasLeadError(form) &&
      (!hasContactPostedSuccessUrl() || contactSuccessUrlMatchesPending(pending, form));
    successContext = leadFormContext(form, 'success');

    params = Object.assign({}, attribution(), successContext, hasPendingContext ? pending : {}, {
      event_id: (hasPendingContext ? pending.lead_event_id : '') || successContext.lead_event_id,
      lead_event_id: (hasPendingContext ? pending.lead_event_id : '') || successContext.lead_event_id,
      value: LEAD_VALUE,
      currency: LEAD_CURRENCY,
      event_label: 'form_submit_success',
      lead_stage: 'form_submit_success',
      form_status: 'success',
      success_source: 'shopify_contact_form',
      success_context_source: hasPendingContext ? 'pending_form_context' : candidate.source,
      selected_success_source: candidate.source,
      success_candidate_count: successCandidates.length,
      fallback: !hasPendingContext,
      is_test: (hasPendingContext && (pending.is_test === true || pending.is_test === 'true')) ||
        successContext.is_test === true ||
        successContext.is_test === 'true' ||
        isTestAttribution(Object.assign({}, attribution(), successContext, hasPendingContext ? pending : {}))
    });

    if (hasLeadSuccessDedupe(params, !hasPendingContext)) {
      markLeadSuccessCandidatesSent(successCandidates);
      if (hasPendingContext) {
        safeSessionRemove(PENDING_LEAD_CONTEXT_KEY);
      }
      return false;
    }

    markLeadSuccessDedupe(params);
    markLeadSuccessCandidatesSent(successCandidates);

    dispatchLeadSuccessWindowEvent(params);
    pushDataLayerEvent(LEAD_SUBMIT_SUCCESS_EVENT, params);
    leadDebug(params, LEAD_SUBMIT_SUCCESS_EVENT + ' dispatched', {
      lead_event_id: params.lead_event_id,
      selected_success_source: params.selected_success_source
    });

    leadSuccessEventsFor(params.form_type).forEach(function (eventName) {
      sendLeadSuccessEvent(eventName, params);
    });

    scheduleLeadNetworkDispatch(params);

    safeSessionRemove(PENDING_LEAD_CONTEXT_KEY);
    return true;
  }

  function ensureLeadSuccessObserver() {
    var observer;

    if (window.__wikaLeadSuccessObserverBound || typeof MutationObserver !== 'function') {
      return;
    }

    if (!freshPendingLeadContext(safeJsonParse(safeSessionGet(PENDING_LEAD_CONTEXT_KEY)))) {
      return;
    }

    window.__wikaLeadSuccessObserverBound = true;
    observer = new MutationObserver(function () {
      if (sendLeadSuccessEvents()) {
        observer.disconnect();
      }
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  function closestLink(target) {
    while (target && target !== document) {
      if (target.tagName === 'A' && target.href) {
        return target;
      }
      target = target.parentNode;
    }

    return null;
  }

  function absoluteHref(link) {
    try {
      return new URL(link.getAttribute('href'), window.location.href).href;
    } catch (error) {
      return link.getAttribute('href') || '';
    }
  }

  function isWhatsappHref(href) {
    return /(^whatsapp:|\/\/wa\.me\/|\/\/api\.whatsapp\.com\/|\/\/chat\.whatsapp\.com\/)/i.test(href);
  }

  function sanitizedLinkUrl(href) {
    try {
      var parsed = new URL(href, window.location.href);
      parsed.searchParams.delete('text');
      return parsed.href;
    } catch (error) {
      return href || '';
    }
  }

  function whatsappLeadEventId() {
    var existing = cleanString(safeSessionGet(WHATSAPP_LEAD_EVENT_KEY));

    if (!existing) {
      existing = createLeadEventId();
      safeSessionSet(WHATSAPP_LEAD_EVENT_KEY, existing);
    }

    return existing;
  }

  function whatsappInquiryCode(leadId) {
    var compact = cleanString(leadId).replace(/[^a-z0-9]/gi, '').toUpperCase();
    return compact.slice(-6) || Math.random().toString(36).slice(2, 8).toUpperCase();
  }

  /* WIKA_P1_CONTEXTUAL_WHATSAPP_PREFILL */
  function whatsappContextMessage(inquiryCode) {
    var context = baseContext();
    var heading = cleanString(pageHeading() || document.title || '').replace(/\s+/g, ' ');
    var leadLine = 'Hi WIKA, I need help with custom eyewear packaging.';

    if (context.page_type === 'product' && heading) {
      leadLine = 'Hi WIKA, I\'m interested in ' + heading + '.';
    } else if (context.page_type === 'collection' && heading) {
      leadLine = 'Hi WIKA, I\'m looking for ' + heading + '.';
    }

    var lines = [
      leadLine,
      'Approximate quantity (or not sure yet): ',
      'Logo / customization: ',
      'Ship to: '
    ];

    if (window.location && window.location.origin && window.location.pathname) {
      lines.push('Page: ' + window.location.origin + window.location.pathname);
    }

    lines.push('WIKA Ref: ' + inquiryCode);
    return lines.join('\n');
  }

  function whatsappPrefillUrl(href, inquiryCode) {
    var referenceLine = 'WIKA Ref: ' + inquiryCode;
    var message = whatsappContextMessage(inquiryCode);

    try {
      var parsed = new URL(href, window.location.href);
      var host = parsed.hostname.toLowerCase().replace(/^www\./, '');
      var pathname = parsed.pathname;
      var existingText = cleanString(parsed.searchParams.get('text'));

      // Owner-confirmed WIKA recipient; preserve unrelated destinations.
      if ((host === 'wa.me' || host === 'api.whatsapp.com') && pathname === '/qr/LG76VWZ4ZKQDO1') {
        parsed = new URL(WHATSAPP_DEFAULT_URL);
      }

      if (existingText) {
        if (!/WIKA\s+Ref\s*:/i.test(existingText)) {
          existingText += '\n' + referenceLine;
        }
        parsed.searchParams.set('text', existingText);
      } else {
        parsed.searchParams.set('text', message);
      }

      return parsed.href;
    } catch (error) {
      return href || WHATSAPP_DEFAULT_URL;
    }
  }

  function safeSessionRemove(key) {
    try {
      if (window.sessionStorage) {
        window.sessionStorage.removeItem(key);
      }
    } catch (error) {
      return;
    }
  }

  function safeJsonParse(value) {
    if (!value) {
      return {};
    }

    try {
      return JSON.parse(value) || {};
    } catch (error) {
      return {};
    }
  }

  function deviceMode() {
    var width = window.innerWidth || document.documentElement.clientWidth || 0;

    if (width <= 749) {
      return 'mobile';
    }

    if (width <= 989) {
      return 'tablet';
    }

    return 'desktop';
  }

  function closestMatching(target, selector) {
    while (target && target !== document) {
      if (target.matches && target.matches(selector)) {
        return target;
      }
      target = target.parentNode;
    }

    return null;
  }

  function sourceContext(element) {
    var explicit = element && element.getAttribute && element.getAttribute('data-source-context');
    var path = window.location ? window.location.pathname : '';

    if (explicit) {
      return explicit;
    }

    if (element && closestMatching(element, '.wk-whatsapp-float')) {
      return 'floating_button';
    }

    if (element && closestMatching(element, '[data-wika-whatsapp-landing]')) {
      return 'whatsapp_landing';
    }

    if (path === '/pages/whatsapp-contact') {
      return 'whatsapp_landing';
    }

    if (element && closestMatching(element, 'header, .shopify-section-header, .header-wrapper')) {
      return 'header';
    }

    if (element && closestMatching(element, 'footer, .footer, .shopify-section-footer')) {
      return 'footer';
    }

    if (path === '/' || path === '') {
      return 'homepage';
    }

    if (path.indexOf('/pages/contact') === 0) {
      return 'contact_page';
    }

    if (path.indexOf('/pages/customization') === 0) {
      return 'customization_page';
    }

    if (path.indexOf('/products/') === 0) {
      return 'product_page';
    }

    if (path.indexOf('/collections/') === 0) {
      return 'collection_page';
    }

    return 'unknown';
  }

  function whatsappEventParams(href, actionType, element) {
    var context = baseContext();
    var text = element ? linkText(element) : '';
    var touch = attribution();
    var leadId = whatsappLeadEventId();
    var inquiryCode = whatsappInquiryCode(leadId);

    return Object.assign(context, {
      link_url: sanitizedLinkUrl(href),
      outbound_destination: 'whatsapp',
      device_mode: deviceMode(),
      inbound_utm_source: urlParam('utm_source'),
      inbound_utm_medium: urlParam('utm_medium'),
      inbound_utm_campaign: urlParam('utm_campaign'),
      inbound_utm_content: urlParam('utm_content'),
      qr_source: urlParam('qr_source'),
      contact_channel: 'whatsapp',
      action_type: actionType || '',
      source_context: sourceContext(element),
      placement: sourceContext(element),
      cta_text: text,
      modal_version: WHATSAPP_MODAL_VERSION,
      lead_event_id: leadId,
      inquiry_code: inquiryCode,
      source_page: context.page_url || pageUrl(),
      first_touch_source: touch.first_touch_source || '',
      first_touch_medium: touch.first_touch_medium || '',
      campaign: touch.first_touch_campaign || touch.last_touch_campaign || '',
      is_test: isTestAttribution(touch)
    });
  }

  function isEmailHref(href) {
    return /^mailto:/i.test(href);
  }

  function linkText(link) {
    return (link.textContent || link.getAttribute('aria-label') || '').replace(/\s+/g, ' ').trim().slice(0, 120);
  }

  function isModifiedClick(event) {
    return !!(event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0);
  }

  function whatsappUrlFromElement(element) {
    if (!element) {
      return WHATSAPP_DEFAULT_URL;
    }

    if (element.getAttribute && element.getAttribute('data-whatsapp-url')) {
      return element.getAttribute('data-whatsapp-url');
    }

    if (element.href) {
      return absoluteHref(element);
    }

    return WHATSAPP_DEFAULT_URL;
  }

  function getWhatsappModal() {
    return document.querySelector('[data-wika-whatsapp-modal]');
  }

  function updateModalTarget(modal, href) {
    var openLinks = modal.querySelectorAll('[data-wika-whatsapp-open]');
    var copyButtons = modal.querySelectorAll('[data-wika-whatsapp-copy]');

    modal.setAttribute('data-whatsapp-url', href);

    Array.prototype.forEach.call(openLinks, function (openLink) {
      openLink.setAttribute('href', href);
    });

    Array.prototype.forEach.call(copyButtons, function (button) {
      button.setAttribute('data-copy-value', href);
    });
  }

  function setModalFeedback(message) {
    var modal = getWhatsappModal();
    var feedback = modal ? modal.querySelector('[data-wika-whatsapp-copy-status]') : null;

    if (!feedback) {
      return;
    }

    feedback.hidden = !message;
    feedback.textContent = message || '';
  }

  var lastModalFocus = null;
  var modalOpenToken = 0;

  function openWhatsappModal(href, trigger) {
    var modal = getWhatsappModal();
    var firstAction;
    var wasHidden;
    var trackedHref = whatsappPrefillUrl(href, whatsappInquiryCode(whatsappLeadEventId()));

    if (!modal) {
      window.location.href = trackedHref;
      return;
    }

    wasHidden = modal.hidden || !modal.classList.contains('is-visible');
    updateModalTarget(modal, trackedHref);
    setModalFeedback('');

    if (wasHidden) {
      lastModalFocus = document.activeElement;
      modalOpenToken += 1;
      modal.setAttribute('data-open-token', String(modalOpenToken));
      modal.hidden = false;
      modal.classList.add('is-visible');
      document.documentElement.classList.add('wika-whatsapp-modal-open');
      firstAction = modal.querySelector('[data-wika-whatsapp-modal-close]') || modal.querySelector('[data-wika-whatsapp-open]');

      if (firstAction && typeof firstAction.focus === 'function') {
        window.setTimeout(function () {
          firstAction.focus();
        }, 0);
      }

      sendEvent('whatsapp_qr_reveal', whatsappEventParams(trackedHref, 'qr_reveal', trigger));
      sendEvent('whatsapp_qr_view', whatsappEventParams(trackedHref, 'qr_view', trigger));
    }
  }

  function closeWhatsappModal() {
    var modal = getWhatsappModal();

    if (!modal) {
      return;
    }

    modal.classList.remove('is-visible');
    modal.hidden = true;
    document.documentElement.classList.remove('wika-whatsapp-modal-open');
    setModalFeedback('');

    if (lastModalFocus && typeof lastModalFocus.focus === 'function') {
      lastModalFocus.focus();
    }

    lastModalFocus = null;
  }

  function navigateAfterTracking(href, target) {
    window.setTimeout(function () {
      if (target && target !== '_self') {
        window.open(href, target, 'noopener');
        return;
      }

      window.location.href = href;
    }, WHATSAPP_EVENT_DELAY);
  }

  function copyText(value) {
    if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
      return navigator.clipboard.writeText(value);
    }

    return new Promise(function (resolve, reject) {
      var textarea = document.createElement('textarea');

      textarea.value = value;
      textarea.setAttribute('readonly', 'readonly');
      textarea.style.position = 'fixed';
      textarea.style.left = '-9999px';
      document.body.appendChild(textarea);
      textarea.select();

      try {
        document.execCommand('copy');
        document.body.removeChild(textarea);
        resolve();
      } catch (error) {
        document.body.removeChild(textarea);
        reject(error);
      }
    });
  }

  function copyWhatsappContact(button) {
    var modal = getWhatsappModal();
    var href = (button && button.getAttribute('data-copy-value')) || (modal && modal.getAttribute('data-whatsapp-url')) || WHATSAPP_DEFAULT_URL;

    sendEvent('whatsapp_number_copy', Object.assign(whatsappEventParams(href, 'number_copy', button), {
      copy_type: button && button.getAttribute('data-copy-type') ? button.getAttribute('data-copy-type') : 'whatsapp_contact_link'
    }));

    copyText(href)
      .then(function () {
        setModalFeedback('Copied.');
      })
      .catch(function () {
        setModalFeedback('Copy failed. Please open WhatsApp instead.');
      });
  }

  function handleWhatsappOpenClick(link) {
    var href = whatsappPrefillUrl(
      whatsappUrlFromElement(link),
      whatsappInquiryCode(whatsappLeadEventId())
    );

    sendWhatsappClickEvents(link, href);
    sendEvent('whatsapp_open_click', whatsappEventParams(href, 'open_whatsapp', link));
  }

  function sendWhatsappClickEvents(link, trackedHref) {
    var href = trackedHref || whatsappPrefillUrl(
      whatsappUrlFromElement(link),
      whatsappInquiryCode(whatsappLeadEventId())
    );
    var params = Object.assign(whatsappEventParams(href, 'whatsapp_click', link), {
      event_category: 'lead',
      event_label: 'whatsapp_click',
      lead_type: 'whatsapp_intent'
    });

    sendEvent('whatsapp_click', params);
    sendEvent('quote_cta_click', Object.assign(baseContext(), {
      event_category: 'lead',
      event_label: 'whatsapp_click',
      contact_method: 'whatsapp',
      cta_text: linkText(link),
      cta_href: sanitizedLinkUrl(href),
      source_context: sourceContext(link),
      lead_event_id: params.lead_event_id,
      inquiry_code: params.inquiry_code,
      source_page: params.source_page,
      first_touch_source: params.first_touch_source,
      first_touch_medium: params.first_touch_medium,
      campaign: params.campaign,
      is_test: params.is_test
    }));
  }

  function handleWhatsappCtaClick(event, link) {
    var href = whatsappPrefillUrl(
      whatsappUrlFromElement(link),
      whatsappInquiryCode(whatsappLeadEventId())
    );
    var target = (link.getAttribute('target') || '').toLowerCase();

    sendWhatsappClickEvents(link, href);

    if (isModifiedClick(event)) {
      return;
    }

    event.preventDefault();
    navigateAfterTracking(href, target || '_self');
  }

  function registerLandingQrView() {
    var landing = document.querySelector('[data-wika-whatsapp-landing]');
    var qr = landing ? landing.querySelector('[data-wika-whatsapp-qr]') : null;
    var href = landing ? landing.getAttribute('data-whatsapp-url') || WHATSAPP_DEFAULT_URL : WHATSAPP_DEFAULT_URL;
    var sent = false;

    if (!landing || !qr || landing.getAttribute('data-qr-view-bound') === 'true' || deviceMode() === 'mobile') {
      return;
    }

    landing.setAttribute('data-qr-view-bound', 'true');

    function sendView() {
      if (sent) {
        return;
      }

      sent = true;
      sendEvent('whatsapp_qr_view', whatsappEventParams(href, 'qr_view', landing));
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            sendView();
            observer.disconnect();
          }
        });
      }, { threshold: 0.35 });

      observer.observe(qr);
      return;
    }

    sendView();
  }

  function registerLandingAutoRedirect() {
    var landing = document.querySelector('[data-wika-whatsapp-landing]');
    var status = landing ? landing.querySelector('[data-wika-whatsapp-status]') : null;
    var href = landing ? landing.getAttribute('data-whatsapp-url') || WHATSAPP_DEFAULT_URL : WHATSAPP_DEFAULT_URL;

    if (!landing || landing.getAttribute('data-auto-redirect-bound') === 'true' || urlParam('auto') !== '1') {
      return;
    }

    landing.setAttribute('data-auto-redirect-bound', 'true');

    if (status) {
      status.hidden = false;
      status.textContent = 'Opening WhatsApp in 2 seconds...';
    }

    window.setTimeout(function () {
      var trackedHref = whatsappPrefillUrl(href, whatsappInquiryCode(whatsappLeadEventId()));
      sendEvent('whatsapp_auto_redirect', whatsappEventParams(trackedHref, 'auto_redirect', landing));
      sendEvent('whatsapp_open_click', whatsappEventParams(trackedHref, 'open_whatsapp', landing));
      navigateAfterTracking(trackedHref);
    }, 2000);
  }

  function isQuoteCta(link, href) {
    var text = linkText(link).toLowerCase();
    var hrefText = href.toLowerCase();
    var hasCtaText = /(quote|contact|inquiry|sample)/.test(text);
    var hasCtaHref = hrefText.indexOf('/pages/contact') !== -1 || hrefText.indexOf('#productinquiryform') !== -1;
    var ctaClass = link.classList.contains('button') || link.classList.contains('wk-primary-link') || link.classList.contains('wkpd-submit');

    return (hasCtaText || hasCtaHref) && (ctaClass || hasCtaHref);
  }

  function quoteCtaParams(link, href, context) {
    var label = link.getAttribute('data-wika-cta-label') || linkText(link);
    var collectionHandle = link.getAttribute('data-collection-handle') || context.collection_handle || '';

    return Object.assign(context, {
      cta_text: linkText(link),
      cta_href: href,
      cta_label: label,
      cta_position: link.getAttribute('data-wika-cta-position') || '',
      collection_handle: collectionHandle,
      source_context: sourceContext(link),
      source_page: link.getAttribute('data-source-page') || context.page_url || ''
    });
  }

  function resetLeadFormPending(form, delayed) {
    form.removeAttribute('aria-busy');
    Array.prototype.forEach.call(form.querySelectorAll('[data-wika-submit-label]'), function (button) {
      button.disabled = false;
      button.textContent = button.getAttribute('data-wika-submit-label');
      button.removeAttribute('data-wika-submit-label');
    });
    var status = form.querySelector('[data-wika-submit-status]');
    if (status) status.textContent = delayed ? 'Submission has not been confirmed. Check your connection or complete any verification before trying again.' : '';
  }

  function setLeadFormPending(form) {
    form.setAttribute('aria-busy', 'true');
    Array.prototype.forEach.call(form.querySelectorAll('button[type="submit"]'), function (button) {
      button.setAttribute('data-wika-submit-label', button.textContent);
      button.disabled = true;
      button.textContent = 'Sending...';
    });
    var status = form.querySelector('[data-wika-submit-status]');
    if (!status) {
      status = document.createElement('p');
      status.setAttribute('data-wika-submit-status', '');
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      form.appendChild(status);
    }
    status.textContent = 'Sending your inquiry. Please keep this tab open and complete any verification shown.';
    window.setTimeout(function () { resetLeadFormPending(form, true); }, 30000);
  }

  function prepareWhatsappLinks() {
    Array.prototype.forEach.call(document.querySelectorAll('a[href]'), function (link) {
      if (link.getAttribute('href').indexOf('https://wa.me/qr/LG76VWZ4ZKQDO1') !== 0) return;
      link.href = whatsappPrefillUrl(link.href, whatsappInquiryCode(whatsappLeadEventId()));
      link.title = 'Open WhatsApp. Sign-in or the app may be required. You can also use our contact form or email.';
    });
  }

  function bindSubmitTracking() {
    document.addEventListener(
      'submit',
      function (event) {
        var form = event.target;

        if (!isLeadForm(form)) {
          return;
        }

        if (event.defaultPrevented) return;
        if (form.getAttribute('aria-busy') === 'true') {
          event.preventDefault();
          return;
        }
        setLeadFormPending(form);
        fillLeadForm(form);
        rememberPendingLeadForm(form);
        ensureLeadSuccessObserver();
      },
      true
    );
  }

  function bindFormStartTracking() {
    document.addEventListener(
      'focusin',
      function (event) {
        var form = closestMatching(event.target, 'form');

        if (!isLeadForm(form) || form.getAttribute('data-wika-form-started') === 'true') {
          return;
        }

        form.setAttribute('data-wika-form-started', 'true');
        fillLeadForm(form);
        sendEvent('form_start', leadFormContext(form, 'start'));
      },
      true
    );
  }

  function bindClickTracking() {
    if (window.__wikaDataClosureClickTrackingBound) {
      return;
    }

    window.__wikaDataClosureClickTrackingBound = true;

    document.addEventListener(
      'click',
      function (event) {
        var closeButton = closestMatching(event.target, '[data-wika-whatsapp-modal-close]');
        var copyButton = closestMatching(event.target, '[data-wika-whatsapp-copy]');
        var openButton = closestMatching(event.target, '[data-wika-whatsapp-open]');
        var link = closestLink(event.target);
        var href;
        var context;
        var modal = getWhatsappModal();

        if (closeButton) {
          event.preventDefault();
          closeWhatsappModal();
          return;
        }

        if (modal && event.target === modal) {
          event.preventDefault();
          closeWhatsappModal();
          return;
        }

        if (copyButton) {
          event.preventDefault();
          copyWhatsappContact(copyButton);
          return;
        }

        if (openButton) {
          handleWhatsappCtaClick(event, openButton);
          return;
        }

        if (!link) {
          return;
        }

        href = absoluteHref(link);
        context = baseContext();

        if (isWhatsappHref(href) || link.hasAttribute('data-wika-whatsapp-trigger')) {
          handleWhatsappCtaClick(event, link);
          return;
        }

        if (isEmailHref(href)) {
          sendEvent('email_click', {
            contact_method: 'email',
            page_url: context.page_url,
            page_type: context.page_type
          });
          return;
        }

        if (isQuoteCta(link, href)) {
          safeSessionSet('wika_last_quote_cta', link.getAttribute('data-wika-cta-label') || linkText(link));
          safeSessionSet('wika_last_quote_source_page', context.page_url || pageUrl());
          sendEvent('quote_cta_click', quoteCtaParams(link, href, context));
        }
      },
      true
    );

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeWhatsappModal();
      }
    });
  }

  function fillVisibleForms() {
    Array.prototype.forEach.call(document.querySelectorAll('form'), fillLeadForm);
  }

  function init() {
    prepareWhatsappLinks();
    landingPage();
    captureAttribution();
    fillVisibleForms();
    retryPendingLeadNetworkDispatch();
    sendLeadSuccessEvents();
    ensureLeadSuccessObserver();
    registerLandingQrView();
    registerLandingAutoRedirect();
  }

  window.wikaDataClosure = {
    closeWhatsappModal: closeWhatsappModal,
    fillForms: fillVisibleForms,
    getAttribution: attribution,
    getWhatsAppInquiryCode: function () {
      return whatsappInquiryCode(whatsappLeadEventId());
    },
    getWhatsAppLeadEventId: whatsappLeadEventId,
    getWhatsAppEventParams: whatsappEventParams,
    getWhatsAppPrefillUrl: function (href) {
      return whatsappPrefillUrl(href, whatsappInquiryCode(whatsappLeadEventId()));
    },
    isTestLead: isTestLead,
    openWhatsappModal: openWhatsappModal,
    sendEvent: sendEvent,
    sendLeadSuccessEvents: sendLeadSuccessEvents
  };

  bindSubmitTracking();
  bindFormStartTracking();
  bindClickTracking();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
  window.addEventListener('load', retryPendingLeadNetworkDispatch);
  window.addEventListener('pageshow', function () {
    Array.prototype.forEach.call(document.querySelectorAll('form[aria-busy="true"]'), function (form) { resetLeadFormPending(form, false); });
    retryPendingLeadNetworkDispatch();
    sendLeadSuccessEvents();
  });
})();
